import React, { useEffect, useRef } from "react"
import "./Error-Component.css";

export default ({
  image,
  text,
  subText,
  buttonText,
  showButton = false,
  textCss,
  subTextCss,
  buttonClickCallback,
  imageHeight,
  imageWidth
}) => {
  const errorRef = useRef();

  useEffect(() => {
    if (errorRef) {
      errorRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }, [])

  return (
    <div className="error-main-container">
      <div className="error-container" ref={errorRef}>
        <img src={image} alt="logo" height={imageHeight} width={imageWidth} />
        <div className="error-text-container">
          <div className={textCss}>{text}</div>
          <div className={subTextCss}>{subText}</div>
        </div>
        {showButton && (
          <div className="error-button-container">
            <button
              type="button"
              className="error-button"
              onClick={buttonClickCallback}
            >
              {buttonText}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
